module.exports = __webpack_public_path__ + "static/img/wjbgc.cda5d632.png";